{
  "carrierLabel": "ਕੈਰੀਅਰ ਕੰਪਨੀ",
  "searchPlaceholder": "ਨਾਮ ਦੁਆਰਾ ਖੋਜੋ",
  "selectAsCarrier": "\"{name}\" ਨੂੰ ਕੈਰੀਅਰ ਵਜੋਂ ਚੁਣੋ",
  "typeToSearch": "ਕੰਪਨੀ ਖੋਜਣ ਲਈ ਟਾਈਪ ਕਰੋ"
}
